import { render, staticRenderFns } from "./PendingCampaigns.vue?vue&type=template&id=c919cbae&scoped=true"
import script from "./PendingCampaigns.vue?vue&type=script&lang=ts"
export * from "./PendingCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./PendingCampaigns.vue?vue&type=style&index=0&id=c919cbae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c919cbae",
  null
  
)

export default component.exports